import $ from 'jquery';
import Api from "../util/Api";
import Popup from "../util/Popup";
import SelectService from "../service/SelectService";

const addressForms = $('.address-form');
if (addressForms.length) {
    let isFormProcessing = false;

    addressForms.on('submit', function(event) {
        event.preventDefault();

        if (isFormProcessing) {
            return;
        }

        isFormProcessing = true;

        const data = {};
        $(this).serializeArray().forEach((param) => {
            data[param.name] = param.value;
        });

        Api.post(data.address_id ? '/api/address/update/' : '/api/address/add/', data)
            .then((response) => {
                if (response.status === 'success') {
                    Popup.notify(response.message);
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                } else {
                    isFormProcessing = false;
                    Popup.notify(response.errorMessage);
                }
            })
            .catch(() => {
                isFormProcessing = false;
                Popup.notify('Something went wrong, check if the entered data is correct.');
            });
    });

    $('.address-form-buttons__set-default').on('click', function(event) {
        if (isFormProcessing) {
            return;
        }

        isFormProcessing = true;

        const data = {
            address_id: $(this).parents('.address-form').data('id'),
        };

        Api.post('/api/address/set-default/', data)
            .then((response) => {
                if (response.status === 'success') {
                    window.location.reload();
                } else {
                    isFormProcessing = false;
                    Popup.notify('Something went wrong, please try again later.');
                }
            })
            .catch(() => {
                isFormProcessing = false;
                Popup.notify('Something went wrong, check if the entered data is correct.');
            });
    });

    $('.address-form-buttons__delete').on('click', function(event) {
        if (isFormProcessing) {
            return;
        }

        isFormProcessing = true;

        const data = {
            address_id: $(this).parents('.address-form').data('id'),
        };

        Api.post('/api/address/delete/', data)
            .then((response) => {
                if (response.status === 'success') {
                    Popup.notify(response.message);
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                } else {
                    isFormProcessing = false;
                    Popup.notify(response.errorMessage);
                }
            })
            .catch(() => {
                isFormProcessing = false;
                Popup.notify('Something went wrong, check if the entered data is correct.');
            });
    });

    $('.personal__add-new-address').on('click', function () {
        $(this).addClass('hidden');
        $('.accordion--new-address').removeClass('hidden');
    });

    // Автозаполнение адреса
    let allCities = [];
    let stateNames = {};
    setTimeout(function () {
        Api.get('/api/places/find-city/', {query: ''}).then((response) => {
            if (response.status === 'success') {
                allCities = response.result.map((city) => {
                    return {...city, nameLower: city.name.toLowerCase()}
                });
            }
        });
    }, 1000);
    setTimeout(function () {
        Api.get('/api/places/find-state/', {query: ''}).then((response) => {
            if (response.status === 'success') {
                response.result.forEach((state) => {
                    stateNames[state.id] = state.name;
                });
            }
        });
    }, 1500);

    addressForms.each(function () {
        const form = $(this);
        const addressId = form.data('id');

        let isAddressChanging = false;
        let selectedState = null;

        form.find('[name=country]').on('change', function () {
            if ($(this).val() === 'India') {
                form.find('.control--india').removeClass('hidden');
                form.find('.control--other-country').addClass('hidden');
            } else {
                form.find('.control--india').addClass('hidden');
                form.find('.control--other-country').removeClass('hidden');
            }
        });

        SelectService.onChange(`address-${addressId}-state`, function (value) {
            if (!value) {
                selectedState = null;
                return;
            }
            if (value === selectedState) {
                return;
            }

            if (selectedState) {
                SelectService.setValue(`address-${addressId}-city`, false);
                SelectService.setOptions(`address-${addressId}-city`, []);
            }

            selectedState = value;
            // const filteredCities = allCities.filter(city => city.state_id === selectedState);

            // SelectService.setOptions(`address-${addressId}-city`, filteredCities);
            // SelectService.setOptions(`address-${addressId}-postcode`, filteredCities.map((city) => {
            //     return {
            //         id: city.id,
            //         name: city.pin,
            //     };
            // }), true, 'name');

            form.find('[name=state]').val(stateNames[selectedState] || '-');
        });

        SelectService.onChange(`address-${addressId}-city`, function (value) {
            if (!value || isAddressChanging) {
                return;
            }
            isAddressChanging = true;

            if (!selectedState) {
                const selectedCity = allCities.find(city => city.id === value);
                SelectService.setValue(`address-${addressId}-state`, selectedCity.state_id);
            }
            // SelectService.setValue(`address-${addressId}-postcode`, value);

            setTimeout(() => {isAddressChanging = false;}, 200);
        });

        SelectService.onInput(`address-${addressId}-city`, function (value) {
            if (value.length) {
                if (!selectedState) {
                    SelectService.setOptions(`address-${addressId}-city`, allCities.filter((city) => {
                        return city.nameLower.indexOf(value.toLowerCase()) === 0;
                    }));
                } else {
                    SelectService.setOptions(`address-${addressId}-city`, allCities.filter((city) => {
                        return city.state_id === selectedState && city.nameLower.indexOf(value.toLowerCase()) === 0;
                    }));
                }
            } else {
                SelectService.setOptions(`address-${addressId}-city`, []);
            }
        });

        // SelectService.onChange(`address-${addressId}-postcode`, function (value) {
        //     if (!value || isAddressChanging) {
        //         return;
        //     }
        //     isAddressChanging = true;
        //
        //     if (!selectedState) {
        //         const selectedCity = allCities.find(city => city.id === value);
        //         SelectService.setValue(`address-${addressId}-state`, selectedCity.state_id);
        //     }
        //     SelectService.setValue(`address-${addressId}-city`, value);
        //
        //     setTimeout(() => {isAddressChanging = false;}, 200);
        // });
        //
        // SelectService.onInput(`address-${addressId}-postcode`, function (value) {
        //     if (!selectedState) {
        //         if (value.length >= 3) {
        //             SelectService.setOptions(`address-${addressId}-postcode`, allCities.filter((city) => {
        //                 return city.pin.indexOf(value) !== -1;
        //             }).map((city) => {
        //                 return {
        //                     id: city.id,
        //                     name: city.pin,
        //                 };
        //             }), true, 'name');
        //         } else {
        //             SelectService.setOptions(`address-${addressId}-postcode`, []);
        //         }
        //     }
        // });
    });
}
